import { formatarQuantidade } from './quantidade.js';
import './SaldoDaAbertura.css';

/**
 * Uma quantidade da movimentação em duas etapas, em mono (RF-041) e nomeada
 * para o leitor de tela: numa linha com três números lado a lado, "10 4 6"
 * não diz qual é o pendente.
 */
export function Quantidade({
  rotulo,
  valor,
  destaque = false,
}: {
  readonly rotulo: string;
  readonly valor: string;
  readonly destaque?: boolean;
}) {
  return (
    <span
      className={destaque ? 'quantidade quantidade--destaque' : 'quantidade'}
      aria-label={rotulo}
    >
      {formatarQuantidade(valor)}
    </span>
  );
}

export type ItemDoSaldo = {
  readonly rotulo: string;
  readonly valor: string;
  readonly destaque?: boolean;
};

/**
 * O saldo escrito por extenso — rótulo em cima, número embaixo. É como o
 * início e a divergência se leem: o supervisor compara números, e cada um
 * precisa dizer o que é.
 */
export function Saldo({ itens }: { readonly itens: readonly ItemDoSaldo[] }) {
  return (
    <dl className="saldo">
      {itens.map((item) => (
        <div key={item.rotulo} className="saldo__item">
          <dt className="saldo__rotulo">{item.rotulo}</dt>
          <dd className="saldo__valor">
            <Quantidade rotulo={item.rotulo} valor={item.valor} destaque={item.destaque === true} />
          </dd>
        </div>
      ))}
    </dl>
  );
}
